import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

domReady(() => {
  const carousel = document.querySelector(
    '.block-missing-persons-carousel__carousel'
  );

  if (carousel) {
    new Swiper(carousel, {
      slidesPerView: 1,
      spaceBetween: 40,
      centerInsufficientSlides: false,

      breakpoints: {
        768: {
          slidesPerView: 2,
        },
        992: {
          slidesPerView: 3,
          spaceBetween: 80,
        },
      },
      navigation: {
        nextEl: '.swiper-navigation .swiper-button-next',
        prevEl: '.swiper-navigation .swiper-button-prev',
      },
    });
  }
});
